var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
import Icons from '../icon';
import { outlined, elevated, filled } from './styles';
function IconWrapper(_a) {
    var iconName = _a.iconName, props = __rest(_a, ["iconName"]);
    var Icon = Icons[iconName];
    return _jsx(Icon, __assign({}, props));
}
export var variants = ['filled', 'outlined', 'elevated'];
export var Colorvariants = ['disabled', 'inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning', 'action'];
export default function PFChip(_a) {
    var sx = _a.sx, iconName = _a.iconName, iconColor = _a.iconColor, _b = _a.pfVariant, pfVariant = _b === void 0 ? 'filled' : _b, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, props = __rest(_a, ["sx", "iconName", "iconColor", "pfVariant", "backgroundColor", "borderColor"]);
    var sxVariants = {
        outlined: outlined,
        elevated: elevated,
        filled: filled,
    };
    var prop = __assign({}, props);
    delete prop.onDelete;
    return (_jsx(Chip, __assign({ icon: iconName ? _jsx(IconWrapper, { color: iconColor || 'inherit', iconName: iconName }) : undefined, sx: __assign({ backgroundColor: backgroundColor, borderColor: borderColor }, (pfVariant ? __assign(__assign(__assign({}, sx), sxVariants[pfVariant]), sx) : sx)) }, props)));
}
